module.exports = __webpack_public_path__ + "img/contributions3Off.092d7b74.svg";